"use client";

import { createContext, useContext } from "react";

/**
 * EdgenDrawer（底部 sheet + draggable）与内部列表滚动协调：
 * - ChatContent 将「唯一 canonical」滚动节点注册到此上下文
 * - useDraggable 仅在 canonical scrollTop===0 时从列表区域接管下拉关闭手势
 */
export type DrawerCanonicalScrollContextValue =
  | { readonly mode: "inactive" }
  | {
      readonly mode: "active";
      readonly registerCanonicalScrollRoot: (el: HTMLElement | null) => void;
    };

export const DrawerCanonicalScrollContext =
  createContext<DrawerCanonicalScrollContextValue>({ mode: "inactive" });

export function useDrawerCanonicalScrollContext(): DrawerCanonicalScrollContextValue {
  return useContext(DrawerCanonicalScrollContext);
}
